import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import JobSurveyItems from "./JobSurveyItems";
import dayjs from "dayjs";

const NewJobSheet = () => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems, surveyedSummary } = useSelector(
    (state: any) => state.leadSurvey,
  );

  console.log("surveyedItems", surveyedItems);
  const materials =
    surveyedItems?.list
      ?.find((item: any) => item.name === "Materials")
      ?.items?.filter((mat: any) => Number(mat.quantity) > 0) || [];

const resourceData =
  surveyedItems?.list
    ?.find((item: any) => item.name === "Resources")
    ?.items?.filter((item: any) => Number(item.quantity) > 0) || [];

  const movingFrom =
    leadDetails?.lead?.collection_address?.[0] ??
    surveyedSummary?.lead?.moving_from?.[0];
  const movingTo =
    leadDetails?.lead?.delivery_address?.[0] ??
    surveyedSummary?.lead?.moving_to?.[0];
  const movingFromVolume = Array.isArray(leadDetails?.lead?.collection_address)
    ? leadDetails.lead.collection_address
    : [];
  const formatAddress = (addr: any) => {
    if (!addr) return "";

    return `${addr.building_number || ""} ${addr.street || ""}
  ${addr.town || ""}, ${addr.county || ""}, ${addr.country || ""}
  ${addr.postcode || ""}`;
  };

  // Separate by flags
  const allSurveyedItems =
    surveyedItems?.list?.map((cat: any) => cat.items).flat() || [];

  const leaveItems = allSurveyedItems
    .filter((it: any) => it.isLeave && Number(it.quantity) > 0)
    .map(
      (it: any) =>
        `${it.item} X ${it.quantity} ${it?.linkedItem ? `X ${it.linkedItem}` : ""}`,
    );
  const weeeItems = allSurveyedItems
    .filter((it: any) => it.isWeee && Number(it.quantity) > 0)
    .map(
      (it: any) =>
        `${it.item} X ${it.quantity} ${it?.linkedItem ? `X ${it.linkedItem}` : ""}`,
    );
  const custItems = allSurveyedItems
    .filter((it: any) => it.isCust && Number(it.quantity) > 0)
    .map(
      (it: any) =>
        `${it.item} X ${it.quantity} ${it?.linkedItem ? `X ${it.linkedItem}` : ""}`,
    );

  const totalVolumeM3 = movingFromVolume?.reduce((sum: any, item: any) => {
    let volume = Number(item.volume) || 0;

    if (item.volume_unit === "ft3") {
      volume = volume * 0.0283168; // convert ft3 → m3
    }

    return sum + volume;
  }, 0);

  const linkedItems =
    surveyedItems?.list
      ?.flatMap((category: any) => category.items || [])
      .filter((item: any) => item.linkedItem != null && item.linkedItem !== "")
      .map((item: any) => ({
        item: item.item,
        quantity: item.quantity,
        linkedItem: item.linkedItem,
      })) || [];

  console.log("linkedItems", linkedItems);

  console.log("materials", materials);

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography fontWeight={600}>FUEL:</Typography>
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>NAME:</Typography>
          {leadDetails?.lead?.customer_name}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>TELEPHONE:</Typography>
          {leadDetails?.lead?.customer_phone}
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid item xs={4}>
          <Typography fontWeight={600}>JOB TYPE:</Typography>
          MOVE
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>DATE</Typography>
          {surveyedSummary?.lead?.removalDate
            ? dayjs(surveyedSummary?.lead?.removalDate)?.format("DD/MM/YYYY")
            : leadDetails?.lead?.moving_on_date
              ? dayjs(leadDetails?.lead?.moving_on_date)?.format("DD/MM/YYYY")
              : "N/A"}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>TIME ON SITE</Typography>
        </Grid>
      </Grid>

      {/* MOVING FROM / TO */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: "50%" }} sx={headerCell}>
              MOVING FROM
            </TableCell>
            <TableCell style={{ width: "50%" }} sx={headerCell}>
              MOVING TO
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>
              {formatAddress(movingFrom)}
              <br />
              <b>Bedrooms:</b> {movingFrom?.house_size}
              <br />
              <b>Floors / Levels:</b> {movingFrom?.floors}
              <br />
              <b>Lift:</b> {movingFrom?.lift_availability}
              <br />
              <b>Type:</b> {movingFrom?.type}
              <br />
              <b>External Flights:</b> {movingFrom?.flight_of_stairs}
            </TableCell>

            <TableCell sx={cell}>
              {formatAddress(movingTo)}
              <br />
              <b>Bedrooms:</b> {movingTo?.house_size}
              <br />
              <b>Floors / Levels:</b> {movingTo?.floors}
              <br />
              <b>Lift:</b> {movingTo?.lift_availability}
              <br />
              <b>Type:</b> {movingTo?.type}
              <br />
              <b>External Flights:</b> {movingTo?.flight_of_stairs}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* PAYMENT METHOD */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell colSpan={3} sx={headerCell}>
              PAYMENT METHOD
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell} width={"30%"}>
              <b>COLLECTION CASH</b>
              <br />
              <b>-</b>
            </TableCell>
            <TableCell sx={cell} width={"40%"}>
              <b>
                NEEDS TO PAY BEFORE UNLOADING (Please call office once loaded)
              </b>
            </TableCell>
            <TableCell sx={cell} width={"30%"}>
              <b>PAID</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* KEY WAITING */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width={"30%"}>
              <b>KEY WAITING:</b>
              <br />
            </TableCell>
            <TableCell sx={cell} width={"30%"}>
              <b>HAS KEYS ON THE DAY</b>
              <br />
            </TableCell>
            <TableCell sx={cell} width={"40%"}>
              <b>GETTING KEYS ON THE DAY</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* DISMANTLE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width={"50%"}>
              <b>COMPANY DISMANTLE:</b>
              <br />
              {weeeItems?.join(" | ")}
            </TableCell>

            <TableCell sx={cell} width={"50%"}>
              <b>Furniture fixtures given to customer by:</b>
              <br />
              Customer signature: __________________
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER PACK */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} style={{ textAlign: "center" }} colSpan={2}>
              <b>CUSTOMER HAS AGREED THEY HAVE COMPLETED PACKING</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>YES</b>
            </TableCell>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>NO</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell} style={{ textAlign: "center" }} colSpan={2}>
              <b>CUSTOMER NEEDS HELP FINISHING PACK</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>YES</b>
            </TableCell>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>NO</b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>List materials taken below:</b>
            </TableCell>
            <TableCell sx={cell} style={{ textAlign: "center" }} width={"50%"}>
              <b>
                List materials used below (NOTIFY OFFICE when finished pack):
              </b>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={cell}
              style={{ textAlign: "center" }}
              width={"50%"}
              height={"100px"}
            ></TableCell>
            <TableCell
              sx={cell}
              style={{ textAlign: "center" }}
              width={"50%"}
              height={"100px"}
            ></TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* RESOURCES */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>RESOURCES REQUIRED:</b>
              <br />
             {resourceData?.length
                ? resourceData.map((mat: any, index: number) => (
                    <span key={index}>
                      {mat.item} X {mat.quantity}
                      <br />
                    </span>
                  ))
                : "N/A"}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER DISMANTLE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>CUSTOMER DISMANTLE:</b> {custItems.join(" | ")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* DO NOT TAKE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>DO NOT TAKE THESE ITEMS:</b> {leaveItems.join(" | ")}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER NOTES */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width={"100%"}>
              <b>CUSTOMER NOTES:</b>{" "} {surveyedSummary?.lead?.customerNotes || leadDetails?.lead?.customer_notes}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <JobSurveyItems />
      {/* TOTAL VOLUME */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>TOTAL VOLUME: {totalVolumeM3.toFixed(2)} m3</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default NewJobSheet;

const cell = {
  border: "1px solid black",
  padding: "6px",
  fontSize: "13px",
};

const headerCell = {
  border: "1px solid black",
  padding: "6px",
  fontWeight: 600,
};
